export default {
  activeTabName(state, value) {
    return (state.activeTabName = value);
  },
};
